import React, { Component } from 'react';
import { Card, CardTitle, CardText, Row, Col } from 'reactstrap';
class Footer extends Component {
    render() {
        return (
            <div>
                <Row>
                    <Col sm="4" style={{marginBottom:'10px'}}>
                        <Card body>
                            <CardTitle>Contact Us</CardTitle>
                            <CardText>
                                <b>Phone: </b> 0088-888-8888 <br/>
                                <b>Email: </b> joe.smith(@)gmail.com <br/>
                                <b>Twitter: </b> (@)joe.smith
                            </CardText>
                        </Card>
                    </Col>
                    <Col sm="4" style={{marginBottom:'10px'}}>
                        <Card body>
                            <CardTitle>Our Services</CardTitle>
                            <CardText>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</CardText>
                        </Card>
                    </Col>
                    <Col sm="4" style={{marginBottom:'10px'}}>
                        <Card body>
                            <CardTitle>Special Manufacturers</CardTitle>
                            <CardText>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</CardText>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Card body>
                            <small>Copyright &copy; 2018 Rezade.ir</small>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer/footer.js